import { render } from "./LocationPriceModal.vue?vue&type=template&id=34749969"
import script from "./LocationPriceModal.vue?vue&type=script&lang=js"
export * from "./LocationPriceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__